import { Link } from 'react-router-dom';

import style from './PlanConditionsLink.module.scss';

type Props = {
    text: string;
    link: string;
};

export function PlanConditionsLink({ text, link }: Props): React.ReactElement<any> {
    return (
        <Link
            className={style.root}
            to={link}
            target={'_blank'}
        >
            {text}
        </Link>
    );
}
